import { useEffect } from "react";
import { isLocal, isDevelopment } from "@/config/prefs";

export function InjectMetaPixel({ email }: { email: string }) {
  useEffect(() => {
    if (isLocal || isDevelopment) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
        !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      fbq("init", "1388052136086887",{
      em: "${email}"
      });
      fbq("track", "PageView");
      `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
